// components
import { Container } from 'components/Grid';

// styles
import {
  SessionTitle,
  ListContainer,
  ContentItem,
  Title,
  Paragraph,
  CTA,
  PageWrapper,
} from './ContentColumns.styles';

const total_rewards = [
  {
    title: 'Healthcare (US Only)',
    text: 'We offer competitive medical, dental, and vision coverage for you and your family.',
  },
  {
    title: 'Health Advocacy (US Only)',
    text: 'We have partnered with Health Advocate to provide free employee assistance in finding the right doctors, resolving insurance claims, and coordinating benefits.',
  },
  {
    title: 'HSA/FSA (US Only)',
    text: 'You can use pre-tax dollars to pay for healthcare costs for you and your dependents.',
  },
  {
    title: 'Life and AD&D Insurance (US Only)',
    text: 'Loadsmart provides both Life and Accidental Death and Dismemberment insurance at no cost to you with the options to increase coverage at your own expense.',
  },
  {
    title: 'Short Term/Long Term Disability Insurances (US Only)',
    text: 'Loadsmart provides short and long-term disability coverage at no cost to you.',
  },
  {
    title: 'Flexible PTO/Holidays (US Only)',
    text: 'Enjoy PTO and sick days without a limit, with Manager approval. We also enjoy 10 local and national holidays.',
  },
  {
    title: '401K with Match  (US Only)',
    text: 'We support our employees’ retirement goals by offering an annual match to our Traditional and Roth 401K plans.',
  },
  {
    title: 'Parental leave',
    text: 'We offer four months of paid leave to primary caregivers followed by a month of half-days, also paid. Secondary caregivers can enjoy four weeks of paid time-off.',
  },
  {
    title: 'Company Equity',
    text: 'Ever wanted to have a stake in a company? Upon hire, Loadsmart employees are granted options that vest over a four-year period.',
  },
];

const global_consultants = [
  {
    title: 'Team Building Events',
    text: 'Enjoy local company sponsored events to meet and network with fellow Loadies. Did we mention our annual Hackathon? Every year individuals from across the organization and globe gather in one location to partner with others and pitch their ideas that will shape the future of Loadsmart. ',
  },
];

export function ContentColumns() {
  return (
    <PageWrapper>
      <Container>
        <SessionTitle>Total Rewards at Loadsmart</SessionTitle>
        <ListContainer>
          {total_rewards.map((item, key) => {
            const rKey = `sidepanel-${key}`;

            return (
              <ContentItem key={rKey}>
                <Title>{item.title}</Title>
                <Paragraph>{item.text}</Paragraph>
              </ContentItem>
            );
          })}
        </ListContainer>
      </Container>
      <Container>
        <SessionTitle>Global Independent Consultants</SessionTitle>
        <ListContainer className="single-column">
          {global_consultants.map((item, key) => {
            const rKey = `sidepanel-${key}`;
            return (
              <ContentItem key={rKey}>
                <Title>{item.title}</Title>
                <Paragraph>{item.text}</Paragraph>
              </ContentItem>
            );
          })}
        </ListContainer>
        <CTA
          as="a"
          href="https://secure.justworks.com/benefits/company_benefits_overviews/29ba306f-f655-4920-834b-4fe956d4c165/show"
          target="_blank"
          rel="noreferrer noopener"
        >
          Learn more about our benefits
        </CTA>
      </Container>
    </PageWrapper>
  );
}
